import React, { useState } from 'react'
import { Blacked, ModalContent, ModalHeader, ModalInput, ModalSubmit, ModalTitle, ModalWrapper } from '../styles';
import { Icon } from 'CRM/organism/Main/styles';
import { FaChevronLeft } from 'react-icons/fa6';
import { Input, message } from 'antd'
import API from 'utils/api';
import { useToken } from 'app/hooks';
import { useBranchList } from 'CRM/hooks/GetBranchList';
import {useIsMobile} from "../IsMobile";

export const BranchAdd = ({ setIsAdd }) => {
  const IsMobile = useIsMobile();
  const { data: token } = useToken();
  const { mutate } = useBranchList();
  const [name, setName] = useState('');
  const [desc, setDesc] = useState('');

  const clickSubmit = () => {
    const shouldEdit = window.confirm(`등록하실 내용이 맞습니까? \n 플랫폼: ${name} \n 설명: ${desc}`);
    if(shouldEdit) {
      if(name == '') {
        message.error('지사명은 필수 입력입니다.')
      } else {
        API.post('/system/branch', token + '', {
          name: name,
          desc: desc
        })
        .then((res: any) => {
          if (res.result.success) {
            message.success('추가되었습니다');
            mutate();
            setIsAdd(false);
          }
        })
        .catch((err: any) => {})
      }
    }
  }

  return (
    <>
      <Blacked onClick={() => setIsAdd(false)} />
      <ModalWrapper IsMobile={IsMobile}>
        <ModalHeader>
          <Icon onClick={() => setIsAdd(false)}><FaChevronLeft /></Icon>
          <ModalTitle>지사 추가</ModalTitle>
          <ModalSubmit onClick={clickSubmit}>저장</ModalSubmit>
        </ModalHeader>
        <ModalContent>
          <ModalInput>
            <label htmlFor='name'>지사명 *</label>
            <Input id='name' type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder='상태를 입력해주세요.' />
          </ModalInput>
          <ModalInput>
            <label htmlFor='desc'>설명</label>
            <Input id='desc' type="text" value={desc} onChange={(e) => setDesc(e.target.value)} placeholder='설명을 입력해주세요.' />
          </ModalInput>
        </ModalContent>
      </ModalWrapper>
    </>
  )
}

export default React.memo(BranchAdd);